import React from 'react';

const InputSenha = ({
  id,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  legenda,
  ...rest
}) => {
  const handleClick = (e) => {
    const input = document.querySelector(`#${id}`);
    const btn = input.nextElementSibling;
    const iconeVisualizar = btn.querySelector('i');

    if (input.type === 'password') {
        input.type = 'text';
        iconeVisualizar.className = 'ic-visualizar';
    } else {
        input.type = 'password';
        iconeVisualizar.className = 'ic-nao-visualizar';
    }
  };

  const msgErro = errors && errors[name]?.message;
  
  return (
    <div className={`campo-txt input-senha ${msgErro ? 'erro' : ''}`}>
      <label className={`subtitulo-p`} htmlFor={id}>
        {label}
      </label>

      <div className='input-container input-com-ic input-com-btn'>
        <i className='ic-cadeado input-ic'></i>

        <input
          type='password'
          id={id}
          name={name}
          ref={inputRef}
          className={className}
          autoComplete='off'
          {...rest}
        />

        <button
          type='button'
          className='btn-txt so-icone input-btn btn-show-hide'
          onClick={(e) => handleClick(e)}>
          <i className='ic-nao-visualizar senha'></i>
        </button>
      </div>
      <div className='mensagem legenda'>{legenda} {msgErro}</div>
    </div>
  );
};

export default InputSenha;
